import LogisticsCompany from "@/enum/LogisticsCompany";
import ShopType from "@/enum/ShopType";
import mainServerClient from "@/services/http/mainServerClient";
import { PremiumFunctionType } from "@/services/PremiumValidator";

export function getTasks() {
    return mainServerClient.get<LogisticAuditTask[]>("/audit/list");
}

export interface PostLogisticAuditTaskParams {
    file: Blob;

    logisticsCompany: LogisticsCompany;

    /**
     * yyyy-MM-dd HH:mm:ss
     */
    printedStartDate: string;

    /**
     * yyyy-MM-dd HH:mm:ss
     */
    printedEndDate: string;

    shopIds: string;
}

export enum LogisticAuditTaskStatus {
    COMPLETED = "COMPLETED",
    ERROR = "ERROR",
    PENDING = "PENDING",
}

export interface LogisticAuditTask {
    id: number;
    companyId: number;
    createdDate: string;
    errorMsg: string;
    failureCount: number;
    logisticsCompany: LogisticsCompany;
    printedEndDate: string;
    printedStartDate: string;
    /** @deprecated */
    shopId: number;
    shopIds: number[];
    status: LogisticAuditTaskStatus;
    successCount: number;
}

export function postTask(task: PostLogisticAuditTaskParams) {
    const formData = new FormData();

    formData.append("file", task.file);
    formData.append("logisticsCompany", task.logisticsCompany);
    formData.append("printedStartDate", task.printedStartDate);
    formData.append("printedEndDate", task.printedEndDate);
    formData.append("shopIds", task.shopIds);

    return mainServerClient.post<LogisticAuditTask>("/audit", formData, {
        timeout: 60000,
        pathPremiumValidator() {
            return {
                type: PremiumFunctionType.LOGISTICS_AUDIT,
            };
        },
    });
}

export interface QnPostLogisticAuditTaskParams {
    logisticsCompany: LogisticsCompany;

    /**
     * yyyy-MM-dd HH:mm:ss
     */
    printedStartDate: string;

    /**
     * yyyy-MM-dd HH:mm:ss
     */
    printedEndDate: string;

    shopIds: string;

    excelFileOriginalName: string;

    excelFileSize: number;

    excelFileUrl: string;
}

export function qnPostTask(task: QnPostLogisticAuditTaskParams) {
    return mainServerClient.post<LogisticAuditTask>("/audit/qianniu/audit", task, {
        pathPremiumValidator() {
            return {
                type: PremiumFunctionType.LOGISTICS_AUDIT,
            };
        },
    });
}

export function deleteTask(id: number) {
    return mainServerClient.post(`/audit/delete/${id}`);
}

export interface LogisticsAuditTaskRecord {
    id: number;

    logisticsCompanyName: string;

    /**快递运费 */
    logisticsFee: number;

    /**是否匹配成功 */
    matched: boolean;

    orderIds: string;
    /**图片url */
    pictures: string;

    /**店铺名称 */
    shopName: string;

    shopType: ShopType;

    taskId: number;

    waybillNo: string;
    /**
     * 重量kg
     */
    weight: number;

    /**
     * 订单总重量kg
     */
    orderWeight: number;

    errorMsg?: string;

    estimatedLogisticsFee?: number;

    /** 运单号记录的商品信息 */
    orderItems?: AuditOrderItemInfo[];
}

/**
 * 快递对账单中单个商品项的信息
 *
 * AuditOrderItemInfo
 */
export interface AuditOrderItemInfo {
    /**
     * 本地修改的规格属性
     */
    localSkuProperties?: string;
    /**
     * 图片 URL
     */
    picture?: string;
    /**
     * 商品商家编码
     */
    productExternalId?: string;
    /**
     * 商品在平台的 ID
     */
    productOriginalId?: string;
    /**
     * 打印数量。正数表示数量，负数表示分包（如 -2 表示 1/2 包）
     */
    quantity?: number;
    /**
     * 商品简称
     */
    simpleTitle?: string;
    /**
     * SKU 商家编码
     */
    skuExternalId?: string;
    /**
     * SKU 在平台的 ID
     */
    skuOriginalId?: string;
    /**
     * 规格属性（来自平台）
     */
    skuProperties?: string;
    /**
     * 商品标题
     */
    title?: string;
}

/**
 * 获取快递公司对账匹配列表
 */
export function getTaskRecordList(taskId: number) {
    return mainServerClient.get<LogisticsAuditTaskRecord[]>("/audit/record/list", {
        taskId,
    });
}
